import { render } from "./chat.vue?vue&type=template&id=05d2359e&scoped=true"
import script from "./chat.vue?vue&type=script&lang=ts"
export * from "./chat.vue?vue&type=script&lang=ts"

import "./chat.vue?vue&type=style&index=0&id=05d2359e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-05d2359e"

export default script